import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';

import { InputAdornment } from '@mui/material';

import { TextInput } from './TextInput';
import { isValidPartialNumber, parseTolerantNumber } from '../../../lib/numbers';

type Props = {
  id?: string;
  caption?: string;
  placeholder?: string;
  endIcon?: ReactElement;
  sx?: object;
  error?: string;
  helperText?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  required?: boolean;
  disabled?: boolean;
  margin?: 'dense' | undefined;
  greyBg?: boolean;
  starred?: boolean;
  value: number | undefined;
  onChange: (n: number | undefined) => void;
};

export const NumberInput: FunctionComponent<Props> = ({id, caption, placeholder, endIcon, sx, error, helperText, autoComplete, autoFocus, required, disabled, margin, greyBg, starred, value, onChange}) => {
  const [raw, setRaw] = useState<string>(value == null ? '' : value.toString());

  useEffect(() => {
    const parsed = parseTolerantNumber(raw);
    if (parsed !== value) {
      setRaw(value == null ? '' : value.toString());
    }
  }, [value]);

  return (<TextInput
    id={id}
    caption={caption}
    placeholder={placeholder}
    endIcon={endIcon}
    sx={sx}
    error={error}
    helperText={helperText}
    autoComplete={autoComplete}
    autoFocus={autoFocus}
    required={required}
    disabled={disabled}
    margin={margin}
    greyBg={greyBg}
    starred={starred}
    value={raw}
    onChange={(v: string) => {
      const normalized = (v || '').replace(",", ".");
      if (normalized !== '' && !isValidPartialNumber(normalized)) return;
      setRaw(normalized);
      onChange(parseTolerantNumber(normalized));
    }}
    onBlur={() => {
      const parsed = parseTolerantNumber(raw);
      setRaw(parsed === undefined ? '' : parsed.toString());
      onChange(parsed);
    }}
  />);
};
